import axiosInstance from "../lib/axiosInstance";

class reviewsModel {

    constructor() {
        this.base_url = "/reviews"
    }
    async list(query = []) {
       
        return (await axiosInstance.get(`${this.base_url}?${new URLSearchParams(query)}`)).data;
    }

    
    async reply(id,data=[]) {
        return await axiosInstance.post(`${this.base_url}/${id}/reply`, data);
    }

    async toggleStatus(id) {
        return await axiosInstance.post(`${this.base_url}/${id}/toggle-status?_method=PUT`);
    }
    // async update(id, data = []) {
    //     return await axiosInstance.post(`${this.base_url}/${id}?_method=PUT`, data);
    // }
    // async destroy(id,data=[]) {
    //     return await axiosInstance.delete(`${this.base_url}/${id}`, data);
    // }
    // async show(id) {
    //     return (await axiosInstance.get(`${this.base_url}/${id}`)).data;
    // }

}

export default new reviewsModel();